(() => {
	class BackToTopElement extends HTMLElement {
		constructor() {
			super();
			this.handleScrollVisibility = this.handleScrollVisibility.bind(this);
			this.lastScrollPosition = 0; // Position précédente du scroll
		}
		connectedCallback() {
			this.backToTopElement = this;
			this.scrollToTopButton = this.querySelector("button");
			this.addEventListeners();
		}
		addEventListeners() {
			if (this.backToTopElement) {
				this.handleScrollVisibility(window.scrollY);
				window.addEventListener("scroll", this.handleScrollVisibility);
			}
			if (this.scrollToTopButton) {
				this.scrollToTopButton.addEventListener("click", this.scrollToTop);
			}
		}
		scrollToTop() {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
		handleScrollVisibility() {
			const currentScrollPosition = window.scrollY;

			if (currentScrollPosition > 400 && currentScrollPosition < this.lastScrollPosition) {
				this.backToTopElement.classList.add("back-to-top--visible");
			} else {
				this.backToTopElement.classList.remove("back-to-top--visible");
			}

			this.lastScrollPosition = currentScrollPosition;
		}
	}
	customElements.define("w3-back-to-top", BackToTopElement);


	class ExpandableElement extends HTMLElement {
		constructor() {
			super();
			this.toggleExpandState = this.toggleExpandState.bind(this);
		}
		connectedCallback() {
			this.expandableElement = this;
			this.expandableContent = this.expandableElement.querySelector(".js-expand-content");
			this.expandButton = this.expandableElement.querySelector(".js-expand-button");
			this.collapsedHeight = parseInt(this.expandableElement.dataset.height);
			this.fullContentHeight = this.expandableContent.offsetHeight;
			if (this.fullContentHeight > this.collapsedHeight) {
				this.expandableElement.style.setProperty("--before-expand-height", `${this.collapsedHeight}px`);
				this.expandableElement.style.setProperty("--expanded-height", `${this.fullContentHeight}px`);
				this.expandButton.addEventListener("click", this.toggleExpandState);
			} else {
				this.expandButton.style.display = "none";
				this.expandableContent.classList.add("expand--small");
			}
		}
		toggleExpandState() {
			let isExpanded = this.expandableElement.classList.toggle("expand--expanded");
			this.expandableContent.ontransitionend = () => {
				if (!isExpanded) {
					this.expandableElement.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			};
		}
	}
	customElements.define("w3-expand", ExpandableElement);


	class FooterTabs extends HTMLElement {
		constructor() {
			super();
		}
		connectedCallback() {
			this.detailsElements = this.querySelectorAll("details");
			this.updateOpenAttributes();
			window.addEventListener("resize", () => {
				this.updateOpenAttributes();
			});
		}
		updateOpenAttributes() {
			if ("matchMedia" in window) {
				if (window.matchMedia("(min-width:1024px)").matches) {
					for (let detailsElement = 0; detailsElement < this.detailsElements.length; detailsElement++) {
						this.detailsElements[detailsElement].setAttribute("open", "open");
					}
				} else {
					for (let detailsElement = 0; detailsElement < this.detailsElements.length; detailsElement++) {
						this.detailsElements[detailsElement].removeAttribute("open");
					}
				}
			}
		}
	}
	customElements.define("footer-tabs", FooterTabs);


	class LocalizationSwitcherElement extends HTMLElement {
		constructor() {
			super();
			this.bindEvents = this.bindEvents.bind(this);
		}
		connectedCallback() {
			this.LocalizationSwitcher = this;
			this.languageButtons = this.LocalizationSwitcher.querySelectorAll(".js-localization-button");
			if (this.languageButtons && this.languageButtons.length !== 0) {
				this.bindEvents();
			}
		}
		bindEvents() {
			for (let button of this.languageButtons) {
				button.addEventListener("click", (event) => {
					this.submitLocalization(event);
				});
			}
		}
		submitLocalization(event) {
			event.preventDefault();
			let form = event.target.form;
			form.querySelector('[name="language_code"]').value = event.target.dataset.value;
			form.submit();
		}
	}
	customElements.define("w3-localization-switcher", LocalizationSwitcherElement);


	class StickyHeader extends HTMLElement {
		constructor() {
			let scrollHandler;
			let debounceTimer;
			super();
			this.hide = this.hide.bind(this);
			this.reveal = this.reveal.bind(this);
			this.reset = this.reset.bind(this);
			this.stick = this.stick.bind(this);
			this.bindEvents = this.bindEvents.bind(this);

			this.onScroll = ((scrollHandler = this.onScroll.bind(this)), function (...args) {
				clearTimeout(debounceTimer);
				debounceTimer = setTimeout(() => scrollHandler.apply(this, args), 10);
			});
		}
		connectedCallback() {
			this.header = document.querySelector(".shopify-section-header");
			this.stickyOffset = this.header?.getBoundingClientRect().top + 40;
			this.currentHeaderState = "normal";
			this.isHeaderSticky = false;
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.isRunning = false;
			this.hideOffset = 400;
			if (this.header) {
				this.bindEvents();
			}
		}
		bindEvents() {
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
			this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
			window.addEventListener("scroll", this.onScroll, false);
			if (this.header) {
				this.checkIfHeaderStick();
			}
		}
		onScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop <= 0) {
				this.reset();
			} else if (scrollTop > this.currentScrollTop && !this.isHeaderSticky) {
				this.stick();
			} else if (scrollTop > this.currentScrollTop && scrollTop > this.hideOffset && this.isHeaderSticky) {
				this.hide();
			} else if (scrollTop < this.currentScrollTop && this.isHeaderSticky) {
				if (this.preventReveal) {
					window.clearTimeout(this.isScrolling);
					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);
					this.hide();
				} else {
					this.reveal();
				}
			} else if (!this.isHeaderSticky) {
				this.reset();
			}
			this.currentScrollTop = scrollTop;
		}
		stick() {
			this.header.classList.add("shopify-section-header-sticky");
		}
		hide() {
			if (this.isRunning || this.currentHeaderState === "hidden") return;
			this.isRunning = true;
			this.header.classList.add("shopify-section-header-hidden");
			this.currentHeaderState = "hidden";
			this.isRunning = false;
		}
		reveal() {
			if (this.isRunning || this.currentHeaderState === "revealed") return;
			this.isRunning = true;
			this.header.classList.add("shopify-section-header-sticky", "header-sticky-transition");
			this.header.classList.remove("shopify-section-header-hidden");
			this.currentHeaderState = "revealed";
			this.isRunning = false;
		}
		reset() {
			if (this.isRunning || this.currentHeaderState === "normal") {return;}
			this.isRunning = true;
			this.header.classList.remove(
				"shopify-section-header-hidden",
				"shopify-section-header-sticky",
				"header-sticky-transition"
			);
			this.currentHeaderState = "normal";
			this.isRunning = false;
		}
		checkIfHeaderStick() {
			new IntersectionObserver(
				([entry]) => (this.isHeaderSticky = entry.intersectionRatio < 1),
				{ threshold: [1] }
			).observe(this.header);
		}
	}
	customElements.define("w3-sticky-header", StickyHeader);


	// Code to re-render product form after variant change
	class VariantRadios extends HTMLElement {
		constructor() {
			super();
		}
		connectedCallback() {
			if (this.hasAttribute("gong-pack-variant")){
				return;
			}
			this.sectionId = this.dataset.section;
			this.productUrl = this.dataset.url;
			this.disableUrlUpdate = this.hasAttribute("disable-url-update") || false;
			this.eventOnChange = this.hasAttribute("event-on-change") || false;
			this.selectedOption = {};
			this.currentVariant = {};
			this.availableOptions = [];
			const optionsData = this.getAttribute("data-options");
			if (optionsData) {
				this.availableOptions = optionsData.split(",");
			}
			this.productForm = document.getElementById(`product-form-${this.sectionId}`);
			this.addButton = this.productForm.querySelector('[name="add"]');
			this.addButtonText = this.addButton.querySelector("span");
			this.updateOptions();
			this.updateCurrentVariant();
			this.addEventListener("change", this.onVariantChange.bind(this));
		}
		onVariantChange() {
			this.updateOptions();
			this.updateCurrentVariant();
			if (this.currentVariant) {
				this.updateURL();
				this.updateVariantInput();
				this.renderProductInfo();
			} else {
				this.toggleAddButton(true, "", true);
			}
			if (this.eventOnChange) {
				this.dispatchEvent(
					new CustomEvent("onvariantchange", {
						bubbles: true,
						detail: { currentVariant: this.currentVariant },
					})
				);
			}
		}
		getSectionsToUpdate() {
			const variantSections = this.availableOptions.map(
				(option) => `product-variant-${option}-${this.sectionId}`
			);
			const optionLists = this.availableOptions.map(
				(option) => `product-option-list-${option}-${this.sectionId}`
			);
			const bundleResumes = this.availableOptions.map(
				(option) => `bundle-resume-${option}-${this.sectionId}`
			);
			const bundleRecaps = this.availableOptions.map(
				(option) => `bundle-recap-${option}-${this.sectionId}`
			);
			return [
				`sku-${this.sectionId}`,
				`Heading-${this.sectionId}`,
				`optional-integrate-products-${this.sectionId}`,
				`optional-integrate-products-drawer-${this.sectionId}`,
				`Price-${this.sectionId}`,
				`product-gallery-${this.sectionId}`,
				`product-tags-${this.sectionId}`,
				`product-delivery-${this.sectionId}`,
				`product-bundle-${this.sectionId}`,
				`product-addtocart-${this.sectionId}`,
				`sticky-add-to-cart-${this.sectionId}`,
				"product-zoom",
				`bundle-navigation-${this.sectionId}`,
				`product-bundle-template-${this.sectionId}`,
				...variantSections,
				...optionLists,
				...bundleResumes,
				...bundleRecaps,
				`product-extra-option-${this.sectionId}`,
			];
		}
		getProductInfoUrl() {
			return `${this.productUrl}?variant=${this.currentVariant.id}&section_id=${this.sectionId}&variant_2=${Date.now()}`;
		}
		updateOptions() {
			const fieldsets = Array.from(this.querySelectorAll("fieldset, .product-options"));
			this.selectedOption = fieldsets.map((fieldset) => {
				const selectedInput = Array.from(fieldset.querySelectorAll("input")).find(
					(input) => input.checked
				);
				return selectedInput?.value;
			});
		}
		updateCurrentVariant() {
			const variants = this.getVariantData();
			this.currentVariant = variants.find((variant) => {
				return !variant.options.map((option, index) => this.selectedOption[index] === option).includes(false);
			});
			if (this.eventOnChange) {
				this.dispatchEvent(new CustomEvent("updatecurrentvariant"));
			}
		}
		updateURL() {
			if (!this.currentVariant || this.disableUrlUpdate) return;
			const url = new URL(window.location.href);
			const variantRadios = document.querySelectorAll("variant-radios");
			[...variantRadios].forEach((radio, index) => {
				let paramName = "variant";
				if (index > 0) {
					paramName = `${paramName}_${index + 1}`;
				}
				url.searchParams.set(paramName, radio.currentVariant.id);
			});
			window.history.replaceState({}, "", url.toString());
		}
		updateVariantInput() {
			const productForms = document.querySelectorAll(
				`#product-form-${this.sectionId}, #product-form-installment`
			);
			for (const form of productForms) {
				const variantRadios = document.querySelectorAll("variant-radios");
				if (variantRadios.length > 1) {
					[...variantRadios].forEach((radio, index) => {
						const inputName = `items[${index}][id]`;
						let input = form.querySelector(`input[name="${inputName}"]`);
						if (!input) {
							input = document.createElement("input");
							input.setAttribute("type", "hidden");
							input.setAttribute("name", inputName);
							form.appendChild(input);
						}
						input.value = radio.currentVariant.id;
						input.dispatchEvent(new Event("change", { bubbles: true }));
					});
				} else {
					let singleInput = form.querySelector('input[name="id"]');
					if (!singleInput) {
						singleInput = document.createElement("input");
						singleInput.setAttribute("type", "hidden");
						singleInput.setAttribute("name", "id");
						form.appendChild(singleInput);
					}
					singleInput.value = variantRadios[0].currentVariant.id;
					singleInput.dispatchEvent(new Event("change", { bubbles: true }));
				}
			}
		}
		renderProductInfo() {
			if(this.productForm === null || this.productForm === undefined) return;
			const formContainer = this.productForm.closest("product-form");
			formContainer?.classList.add("product-form-loading");
			const productInfoUrl = this.getProductInfoUrl();
			this.toggleAddButton(true, "");
			fetch(productInfoUrl)
				.then((response) => {
					if (!response.ok) {
						const error = new Error(response.status);
						this.toggleAddButton(false, "");
						formContainer?.classList.remove("product-form-loading");
						throw error;
					}
					return response.text();
				})
				.then((htmlText) => {
					const parsedHtml = new DOMParser().parseFromString(htmlText, "text/html");
					for (const sectionId of this.getSectionsToUpdate()) {
						const currentSection = document.getElementById(sectionId);
						const updatedSection = parsedHtml.getElementById(sectionId);
						if (currentSection && updatedSection && !currentSection.isEqualNode(updatedSection)) {
							currentSection.innerHTML = updatedSection.innerHTML;
						}
					}
					this.toggleAddButton(!this.currentVariant.available, "");
					formContainer?.classList.remove("product-form-loading");
					if (this.eventOnChange) {
						this.dispatchEvent(
							new Event("onvariantchange:finished", { bubbles: true })
						);
					}
				});
		}
		toggleAddButton(disabled = true, buttonText, resetPointer = true) {
			if (!this.productForm) return;
			const addButton = this.productForm.querySelector('[name="add"]');
			if (disabled) {
				addButton.style.pointerEvents = "none";
			} else {
				addButton.style.pointerEvents = "auto";
				this.addButtonText.textContent = buttonText || window.variantStrings.addToCart;
			}
			if (!resetPointer) return;
		}
		getVariantData() {
			if (!this.variantData) {
				const jsonData = this.querySelector('[type="application/json"]').textContent;
				this.variantData = JSON.parse(jsonData);
			}
			return this.variantData;
		}
	}
	customElements.define("variant-radios", VariantRadios);


	class VariantSelect extends VariantRadios {
		constructor() {
			super();
		}
		updateOptions() {
			this.selectedOption = Array.from(this.querySelectorAll("select"), (select) => select.value);
		}
	}
	customElements.define("variant-select", VariantSelect);

	if (typeof customElements.get("variant-select-cart-product") === "undefined") {
		customElements.define(
			"variant-select-cart-product",
			class extends VariantSelect {
				constructor() {
					super();
				}
				renderProductInfo() {
					const cartProductCard = this.closest(".js-cart-product-card");
					const priceElement = cartProductCard?.querySelector(".js-cart-product-card-price");
					if (priceElement) {
						priceElement.innerHTML = Shopify.formatMoney(this.currentVariant.price).replace(",00", "");
					}
				}
			}
		);
	}
})();
